// Images
import logo from './assets/logo1.png';

export const globalDirectories = {
  logo: logo,
  bestModelRender: logo, // Assuming bestModel is the same as logo for now
};
